// Begin Footer Video
(function () {
  function ensureModal(container) {
    var modal = container.querySelector('.jbg-video-cta__modal');
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'jbg-video-cta__modal';
    modal.hidden = true;

    var inner = document.createElement('div');
    inner.className = 'jbg-video-cta__modal-inner';
    inner.setAttribute('role', 'dialog');
    inner.setAttribute('aria-modal', 'true');
    inner.setAttribute('aria-label', 'Video player');

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'jbg-video-cta__close';
    close.setAttribute('aria-label', 'Close');
    close.textContent = '×';

    var vid = document.createElement('video');
    vid.className = 'jbg-video-cta__video';
    vid.setAttribute('controls', '');
    vid.setAttribute('playsinline', '');

    inner.appendChild(close);
    inner.appendChild(vid);
    modal.appendChild(inner);
    container.appendChild(modal);
    return modal;
  }

  function getVideoSrc(container) {
    var playBtnLink = container.querySelector('.jbg-video-cta__play .wp-block-button__link');
    if (playBtnLink) {
      var direct = (playBtnLink.getAttribute('data-src') || '').trim();
      if (direct) return direct;
    }

    var hiddenVideo = container.querySelector('.jbg-video-cta__source video');
    if (hiddenVideo) {
      var fromCurrent = hiddenVideo.currentSrc || hiddenVideo.getAttribute('src') || '';
      if (fromCurrent) return fromCurrent;
      var firstSource = hiddenVideo.querySelector('source');
      if (firstSource && firstSource.src) return firstSource.src;
    }

    return '';
  }

  function openModal(container) {
    var modal = ensureModal(container);
    var video = modal.querySelector('.jbg-video-cta__video');
    if (!modal || !video) return;

    var src = getVideoSrc(container);
    if (!src) return;

    video.src = src;
    modal.hidden = false;
    document.body.classList.add('jbg-modal-open');

    if (video.play) { video.play().catch(function(){}); }

    var closeBtn = modal.querySelector('.jbg-video-cta__close');
    if (closeBtn && closeBtn.focus) closeBtn.focus({ preventScroll: true });
  }

  function closeModal(modal) {
    var video = modal.querySelector('.jbg-video-cta__video');
    try { video.pause(); } catch(e){}
    video.removeAttribute('src');
    video.load();
    modal.hidden = true;
    document.body.classList.remove('jbg-modal-open');
  }

  document.addEventListener('click', function (e) {
    var playWrap = e.target.closest('.jbg-video-cta__play');
    if (playWrap) {
      var wrap = e.target.closest('.jbg-video-cta');
      if (wrap) openModal(wrap);
      e.preventDefault();
      return;
    }

    var close = e.target.closest('.jbg-video-cta__close');
    if (close) {
      var modal = close.closest('.jbg-video-cta__modal');
      if (modal) closeModal(modal);
      e.preventDefault();
      return;
    }

    var modalEl = e.target.closest('.jbg-video-cta__modal');
    if (modalEl && !e.target.closest('.jbg-video-cta__modal-inner')) {
      closeModal(modalEl);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      var openModalEl = document.querySelector('.jbg-video-cta__modal:not([hidden])');
      if (openModalEl) closeModal(openModalEl);
    }
  });
})();

/* End Footer Video */